module.exports = __webpack_public_path__ + "static/FoundersGroteskMonoTest-Regular-6848a02069e3cb98e1340c2e993b4e00.svg";